import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid2 as Grid } from '@mui/material';
import { ILink } from '../../shared.interfaces';
import { useDispatch } from 'react-redux';
import { setRouteData } from '../../../store/slices/metaDataSlice';
import { TypographyStyledBlack, LinkStyled, Item } from './style';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { ExternalPopupModal } from '../../../shared/components/modal/ExternalPopupModal';
import pcPDF from '../../../assets/pdf/Abbott_Nutrition_Compendium_2025_PDF.pdf';

export const TileComponent = (props: ILink) => {
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const dispatch = useDispatch();
  const { routeData } = useAppSelector(metaDataSelector);
  const handleCloseModal = () => {
    openInfoModal && setOpenInfoModal(false);
  };
  const handleMouseOver = (e): void => {
    const imgElement = e.currentTarget.querySelector('img');
    if (imgElement) {
      imgElement.src = props.imgSrcOnHover;
    }
  };

  const handleMouseOut = (e): void => {
    const imgElement = e.currentTarget.querySelector('img');
    if (imgElement) {
      imgElement.src = props.imgSrc;
    }
  };
  const setNavigation = (e): void => {
    const pElement = e.currentTarget.querySelector('p').innerHTML;
    if (pElement === 'DIRECT TO PATIENT SAMPLE') {
      setOpenInfoModal(true);
    } else if (pElement === 'PRODUCT COMPENDIUM') {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        const link = document.createElement('a');
        link.href = pcPDF;
        link.download = 'Abbott_Nutrition_Compendium_2025.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(pcPDF, '_blank');
      }
    } else {
      dispatch(
        setRouteData({
          ...routeData,
          lastClickedTile: props.tileText
        })
      );
      navigate(props.toLink);
    }
  };

  const navigate = useNavigate();
  return (
    <>
      <Grid
        size={12}
        sx={{
          borderRadius: '0.9375rem',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <LinkStyled
          onClick={setNavigation}
          data-testid={props.altVal}
          onFocus={handleMouseOver}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onBlur={handleMouseOut}
        >
          <Item
            sx={{
              boxShadow: 0,
              display: 'flex',
              justifyContent: 'left',
              gap: '0.625rem',
              alignItems: 'center',
              padding: '1.25rem'
            }}
          >
            <img
              src={props.imgSrc}
              alt={props.altVal}
              style={{ height: '2.5rem', width: '2.5rem' }}
            />
            <TypographyStyledBlack
              sx={{
                color: '#002A3A',
                paddingBlock: '1.125rem',
                lineHeight: '1.5rem'
              }}
              className={'font-size-16'}
            >
              {props.tileText}
            </TypographyStyledBlack>
          </Item>
        </LinkStyled>
      </Grid>
      <ExternalPopupModal
        open={openInfoModal}
        onClose={handleCloseModal}
        externalURL={'https://anieuhcp.my.salesforce-sites.com/SamplesIE'}
      />
    </>
  );
};
